/** @jsx jsx */

import { useRef, useEffect } from 'react';
import { css, jsx } from '@emotion/core';
import { Text } from '@chameleoncreator/creator-ui';
import 'services/ie11closestPolyfill';
import bulletStyles from './bulletStyles';
import { TextToSpeech } from './TextToSpeech';
import { useSelector } from 'react-redux';
import { State } from 'store/store';

const ReadOnlyText = ({
  id,
  content,
  className,
  // useBackgroundControls,
  borderRadius,
  // backgroundColor,
  background,
  bulletColor,
  liTextColor,
  linkColors,
  enableTextToSpeechBtn,
}) => {
  const textToSpeech = useSelector((state: State) => state.theme.textToSpeech);
  // const doc = new DOMParser().parseFromString(content, 'text/html');
  // const textToSpeechContent = doc.body.innerText;

  //
  const readOnlyText = useRef(null);
  const fontInfo = useRef<{ fontSize: number; lineHeight: number } | undefined>(
    undefined
  );

  let padding;

  // if (useBackgroundControls || backgroundColor) {
  if (background) {
    padding = `${12.5 + borderRadius}px ${10 + borderRadius}px`;
  }

  if (!!borderRadius) {
    padding = borderRadius * 3;
  }

  useEffect(() => {
    if (!readOnlyText.current) {
      return;
    }

    const span = (readOnlyText.current as HTMLDivElement).querySelector(
      '[data-type="fontSize"]'
    ) as HTMLSpanElement;

    if (span) {
      fontInfo.current = {
        fontSize: Number(span.style.fontSize.replace(/[^\d.-]+/g, '')),
        lineHeight: Number(span.style.lineHeight.replace(/[^\d.-]+/g, '')),
      };
    }
  }, []);

  return (
    <Text
      ref={readOnlyText}
      className={`chameleon-text${className ? ` ${className}` : ''}`}
      as="div"
      css={css`
        a:link {
          color: ${linkColors.link} !important;
        }

        a:visited {
          color: ${linkColors.visited} !important;
        }

        a:hover {
          color: ${linkColors.hover} !important;
        }

        a:focus-visible {
          color: ${linkColors.focus} !important;

          outline-offset: 2px !important;
          outline: 1px solid ${linkColors.focus} !important;
          text-decoration: none !important;
        }

        a:active {
          color: ${linkColors.active} !important;
        }

        ${bulletStyles(bulletColor, liTextColor)}

        ${fontInfo.current &&
          `
        @media(max-width: 360px) {
          span {
            font-size: ${fontInfo.current?.fontSize * 1.6}vw !important;
            line-height: ${fontInfo.current?.lineHeight / 8}vw !important;
          }
        }
        `}
      `}
      style={
        background
          ? {
              borderRadius,
              background,
              padding: `${12.5 + borderRadius}px ${10 + borderRadius}px`,
            }
          : {}
      }
    >
      <div
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />

      {'speechSynthesis' in window &&
        textToSpeech &&
        enableTextToSpeechBtn &&
        content && (
          <TextToSpeech id={`text-to-speech-${id}`} content={content} />
        )}
    </Text>
  );
};

export default ReadOnlyText;
